module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "title-form"
  }, [_vm._v("Datos de extranet")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Código")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.model.codeChannel),
      callback: function($$v) {
        _vm.model.codeChannel = $$v
      },
      expression: "model.codeChannel"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save btn-save-form mt-3",
    attrs: {
      "type": "button",
      "disabled": !_vm.model.name || !_vm.model.codeChannel
    },
    on: {
      "click": _vm.saveChannel
    }
  }, [_vm._v("\n\t\t\t\t\t\tAceptar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9377637c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/channels/New.vue
// module id = 1685
// module chunks = 16